import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
    name: 'noSanitize',
})
export class NoSanitizePipe implements PipeTransform {
    constructor(private domSanitizer: DomSanitizer) {}

    /**
     * Bypass security and trust the given value to be safe HTML.
     * Only use this when the bound HTML is unsafe (e.g. contains <script> tags) and the code should be executed.
     * The sanitizer will leave safe HTML intact, so in most situations this method should not be used.
     *
     * @param {string} html
     * @returns {SafeHtml}
     * @memberof NoSanitizePipe
     */
    transform(html: string): SafeHtml {
        return this.domSanitizer.bypassSecurityTrustHtml(html);
    }
}
